import React from "react";
import {
  FaShieldHalved,
  FaClockRotateLeft,
  FaHeadset,
  FaFileShield,
} from "react-icons/fa6";
import { useTranslation } from "react-i18next";

type BadgeItem = {
  title: string;
  icon: React.ReactNode;
};

const badges: BadgeItem[] = [
  {
    title: "50+ Countries Supported",
    icon: <FaShieldHalved className="text-2xl md:text-3xl text-brand-pink" />,
  },
  {
    title: "1,000+ Applications Handled",
    icon: <FaClockRotateLeft className="text-2xl md:text-3xl text-brand-pink" />,
  },
  {
    title: "24/7 Customer Assistance",
    icon: <FaHeadset className="text-2xl md:text-3xl text-brand-pink" />,
  },
  {
    title: "End-to-End Guidance",
    icon: <FaFileShield className="text-2xl md:text-3xl text-brand-pink" />,
  },
];

const Badge: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="border-b border-gray-100 bg-white py-10">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 items-center gap-6 opacity-80 md:grid-cols-4 md:gap-8">
          {badges.map((badge) => (
            <div
              key={badge.title}
              className="flex flex-col items-center gap-3 text-center md:flex-row md:text-left"
            >
              {badge.icon}

              <span className="text-xs font-bold uppercase tracking-wide text-gray-800 md:text-sm">
                {t(badge.title)}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Badge;
